import { Box, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

interface SampleButtonProps {
  samplecreation: 'true' | 'false';
}

export const SampleBackButton = styled(IconButton)<SampleButtonProps>(
  ({ samplecreation, theme }) => ({
    position: 'absolute',
    margin: samplecreation === 'true' ? '404px 0 0 -80px' : '304px 0 0 -80px',
    borderRadius: '50%',
    padding: '10px 14px 10px 6px',
    color: theme.palette.secondary.main,
    '&.Mui-disabled': {
      color: '#D7D8DB',
    },
    '& span': {
      fontSize: '48px',
    },
  })
);

export const SampleForwardBox = styled(Box)(() => ({
  display: 'flex',
  width: '100%',
  justifyContent: 'flex-end',
}));

export const SampleForwardButton = styled(IconButton)<SampleButtonProps>(
  ({ samplecreation, theme }) => ({
    float: 'right',
    position: 'absolute',
    margin: samplecreation === 'true' ? '404px -80px 0 0' : '304px -80px 0 0',
    borderRadius: '50%',
    padding: '10px 6px 10px 14px',
    color: theme.palette.secondary.main,
    '&.Mui-disabled': {
      color: '#D7D8DB',
    },
    '& span': {
      fontSize: '48px',
    },
  })
);
